"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toSlate = void 0;
const Slice_1 = require("json-joy/lib/json-crdt-extensions/peritext/slice/Slice");
const constants_1 = require("json-joy/lib/json-crdt-extensions/peritext/slice/constants");
const peritext_1 = require("json-joy/lib/json-crdt-extensions/peritext");
const isText = (node) => typeof node.text === 'string';
const blockToSlateNode = (block) => {
    if (block instanceof peritext_1.LeafBlock) {
        const children = [];
        for (let iterator = block.texts0(), inline; (inline = iterator());) {
            const text = inline.text();
            const attr = inline.attr();
            const attrKeys = Object.keys(attr);
            let atomicSlice;
            let atomicTag;
            for (const tag of attrKeys) {
                const stack = attr[tag];
                if (!stack || stack.length <= 0)
                    continue;
                const slice = stack[0].slice;
                if (!(slice instanceof Slice_1.Slice))
                    continue;
                if (slice.stacking === constants_1.SliceStacking.Atomic) {
                    atomicSlice = slice;
                    atomicTag = tag;
                    break;
                }
            }
            if (atomicSlice && atomicTag !== undefined) {
                const data = atomicSlice.data();
                const inlineEl = {
                    type: atomicTag,
                    children: [{ text: '' }],
                };
                if (data && typeof data === 'object' && !Array.isArray(data))
                    Object.assign(inlineEl, data);
                children.push(inlineEl);
                continue;
            }
            if (!text && attrKeys.length === 0)
                continue;
            const textNode = { text: text || '' };
            const length = attrKeys.length;
            ATTRS: for (let i = 0; i < length; i++) {
                const tag = attrKeys[i];
                const stack = attr[tag];
                if (!stack || stack.length <= 0)
                    continue ATTRS;
                const slice = stack[0].slice;
                if (!(slice instanceof Slice_1.Slice))
                    continue ATTRS;
                if (slice.stacking === constants_1.SliceStacking.Atomic)
                    continue ATTRS;
                const data = slice.data();
                if (data && typeof data === 'object' && !Array.isArray(data))
                    Object.assign(textNode, { [tag]: data });
                else
                    textNode[tag] = data !== undefined ? data : true;
            }
            children.push(textNode);
        }
        // Slate requires text nodes around inline elements; bracket the run
        // with empty text nodes when needed.
        if (children.length === 0) {
            children.push({ text: '' });
        }
        else {
            if (!isText(children[0]))
                children.unshift({ text: '' });
            if (!isText(children[children.length - 1]))
                children.push({ text: '' });
            for (let i = 1; i < children.length; i++) {
                if (!isText(children[i]) && !isText(children[i - 1])) {
                    children.splice(i, 0, { text: '' });
                    i++;
                }
            }
        }
        const node = {
            type: block.tag() + '',
            children: children,
        };
        const attr = block.attr();
        if (typeof attr === 'object')
            Object.assign(node, attr);
        return node;
    }
    else {
        const children = [];
        const blockChildren = block.children;
        const length = blockChildren.length;
        for (let i = 0; i < length; i++)
            children.push(blockToSlateNode(blockChildren[i]));
        const attr = block.attr();
        const node = {
            ...(attr && typeof attr === 'object' ? attr : {}),
            type: block.tag() + '',
            children: children.length ? children : [{ text: '' }],
        };
        return node;
    }
};
const toSlate = (txt) => {
    txt.refresh();
    const block = txt.blocks.root;
    const node = blockToSlateNode(block);
    const content = (node?.children ?? []);
    return content;
};
exports.toSlate = toSlate;
